import { useDroppable } from '@dnd-kit/core'

export const GAP_SPACER_PREFIX = 'gap-spacer-'

interface GapSpacerProps {
  insertIndex: number
  width: number
}

export default function GapSpacer({ insertIndex, width }: GapSpacerProps) {
  const id = `${GAP_SPACER_PREFIX}${insertIndex}`
  const { setNodeRef, isOver } = useDroppable({ id })

  return (
    <div
      ref={setNodeRef}
      className={`gap-spacer${isOver ? ' is-over' : ''}`}
      style={{ gridColumn: `span ${width}` }}
    />
  )
}
